import React from 'react';
// Create a small context that can be used to pass the variant to the accordion subcomponents
export const AccordionVariantContext = React.createContext(undefined);
export const useAccordionVariant = () => React.useContext(AccordionVariantContext);
//# sourceMappingURL=accordionContext.js.map